import { render } from "./LoginScreen.vue?vue&type=template&id=a5872bd4&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=a5872bd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5872bd4"]])

export default __exports__